import { useState, forwardRef, type InputHTMLAttributes } from 'react';
import { Input } from '@/shared/components';
import { I } from '@/shared/icons';

/**
 * Passwortfeld mit Anzeigen/Verbergen.
 *
 * <p>Der Umschalter lag auf drei der vier Anmeldeflächen als nacktes Icon im Feld: rund 16 px
 * Trefferfläche, also weit unter den 44 px aus §9. Auf zwei Seiten fehlte zudem das
 * `pr-12` — der Umschalter lag dort über dem eingegebenen Text. Beides ist hier einmal gelöst,
 * statt viermal unterschiedlich.</p>
 */
export const PasswordInput = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>
>(({ className, ...props }, ref) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <Input
        {...props}
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={className ? `pr-12 ${className}` : 'pr-12'}
      />
      <button
        type="button"
        onClick={() => setVisible((value) => !value)}
        aria-label={visible ? 'Passwort verbergen' : 'Passwort anzeigen'}
        className="text-ink-soft hover:text-ink focus-visible:ring-sage absolute right-1 top-1/2 flex size-11 -translate-y-1/2 items-center justify-center rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2"
      >
        <I name={visible ? 'EyeOff' : 'Eye'} size={16} aria-hidden />
      </button>
    </div>
  );
});
PasswordInput.displayName = 'PasswordInput';
